import script from "./MysticMark.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticMark.vue?vue&type=script&setup=true&lang=js"

import "./MysticMark.vue?vue&type=style&index=0&id=206ac3e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206ac3e3"]])

export default __exports__